import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CorpAdminConstants } from '../../models/constants/corp-admin.constants';
import { MatSelectModule } from '@angular/material/select';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'corp-drop-down',
  imports: [MatFormFieldModule, MatSelectModule, MatIconModule],
  templateUrl: './drop-down.component.html',
  styleUrl: './drop-down.component.scss',
})
export class DropDownComponent {
  @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() dropdownType: string = '';
  @Input() categoryControl: any;
  @Input() selectedCode: string = '';
  @Input() dropdownValues: string[] = [];
  @Input() alreadyUsedCodes: string[] = [];

  codeTitle: string = this.corpAdminConstants.codeValueTitle;
  codePlaceholder: string = this.corpAdminConstants.codeValuePlaceholder;

  constructor(private corpAdminConstants: CorpAdminConstants) {}

  ngOnInit() {}

  onCodeChange(event: any) {
    this.selectedCode = event.value;
    this.selectionChange.emit(this.selectedCode);
  }

  clearCodeSelection() {
    this.selectedCode = '';
    this.selectionChange.emit(this.selectedCode);
  }

  //Disableds used codes in the dropdown and prevents them from being selected again
  //TODO -- in the future this code may need to be adjusted to account for multiple code types, currently only CCI codes
  isCodeUsed(code: string): boolean {
    if (this.alreadyUsedCodes.includes(code)) {
      return true;
    } else {
      return false;
    }
  }
}
